import { render, staticRenderFns } from "./onestukq.vue?vue&type=template&id=7c1d34bb&scoped=true&"
import script from "./onestukq.vue?vue&type=script&lang=js&"
export * from "./onestukq.vue?vue&type=script&lang=js&"
import style0 from "./onestukq.vue?vue&type=style&index=0&id=7c1d34bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d34bb",
  null
  
)

export default component.exports